<div class="d-flex mb-3 shadow p-0 bg-body-tertiary rounded" style="border-radius: 0px 10px 10px 0px; width: 100%; min-height: 8rem;">
    <div class=" d-flex justify-content-around flex-column" style="min-height: 8rem;background-color:rgba({{hexToRgb(data?.color)?.r}}, {{hexToRgb(data?.color)?.g}}, {{hexToRgb(data?.color)?.b}}, .7); width:3%">
    </div>
    <div class="w-100 text-start p-1" style="min-height: 5.5rem;">
        <span *ngIf="current==index" class="text-end"><i class="fa fa-check text-success"></i></span>
        <br *ngIf="current==index">
        {{data.name}}
        <ng-container *ngIf="data.name!=null">
            <span class="fw-bold"><small>{{data?.name}}</small></span>
            <br>
        </ng-container>
        <ng-container *ngIf="data.name==null">
            <span class="fw-bold"><small>{{data?.course}}</small></span>
            <br>
        </ng-container>
        
     
        <span class="p-0"><small>{{data?.classroom}}</small></span>
        <br>
        <span class="p-0"><small>{{data?.professor}}</small></span>
        <br>
        <span class="p-0"><small>{{data?.start}}-{{data?.end}}</small></span>
        <br>
        <span class="p-0"><small>{{data?.date_name}},le {{data?.date}}</small></span>
        <!-- <p>Salles 105
            <span class="float-end">Pas fait <input type="radio" name="" id=""> </span>
        </p> -->
    </div>
</div>